import styled from 'styled-components';

import { getSpace, getColor } from '../../../../../stylesheets/tools';
import { myFuturiumMap } from '../../../../../helper';

const StyledCta = styled.button`
  position: fixed;
  width: 192px;
  height: 237px;
  bottom: 0;
  right: 0;
  z-index: 99;
  overflow: hidden;

  [data-whatinput='mouse'] &,
  [data-whatinput='touch'] & {
    outline: 0;
  }

  .background {
    position: absolute;
    top: 0;
    left: 0;
    color: ${({ plan }) => (plan ? myFuturiumMap(plan, 'color') : '#d1cfcf')};
  }

  .icon {
    position: absolute;
    top: 55%;
    left: 50%;
    fill: ${({ plan }) => (plan ? myFuturiumMap(plan, 'color') : '#000')};
    stroke: ${({ plan }) => (plan ? myFuturiumMap(plan, 'color') : '#000')};
  }

  .label {
    transform: rotate(-39deg);
    transform-origin: left;
    margin: ${getSpace('l')} 0 0;
    color: ${getColor('black')};
  }
`;

export default StyledCta;
